module.exports = __webpack_public_path__ + "static/media/picture-1@2x.1e66c8d4.png";